import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import PropTypes from "prop-types";

const CustomPagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  className 
}) => {
  const handlePageClick = (page) => {
    if (onPageChange && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  if (totalPages <= 1) {
    return null; // No need to render pagination if only one page exists
  }

  return (
    <Pagination className={`d-flex flex-row justify-content-end align-items-center ${className}`}>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink first onClick={() => handlePageClick(1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
      </PaginationItem>
      {[...Array(totalPages)].map((_, i) => (
        <PaginationItem active={i + 1 === currentPage} key={i}>
          <PaginationLink onClick={() => handlePageClick(i + 1)}>
            {i + 1}
          </PaginationLink>
        </PaginationItem>
      ))}
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink last onClick={() => handlePageClick(totalPages)} />
      </PaginationItem>
    </Pagination>
  );
};

CustomPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CustomPagination.defaultProps = {
  className: "",
};

export default CustomPagination;
